<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive :include="arr">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import jsonData from '@/api/datalist'

export default {
  name: 'App',
  data() {
    return {
      arr: [],
      operateCode: 'b6046949-6fbf-11ed-bfc0-043f72e56bda',
    }
  },
  methods: {
    setList() {
      for (var i = 0; i < jsonData.list.length; i++) {
        jsonData.list[i].index = i
      }
      this.$store.commit('SET_FOURLIST', jsonData.list)
    }
  },
  created() {
    this.setList()
    this.$store.commit('SET_SHARETITLE', this.shareTitle)
    this.$store.commit('SET_OPERATECODE', this.operateCode)
  },
  // 缓存列表页记录当前滑动位置
  watch: {
    // 监听router
    $route: function (to, from) {
      // console.log('from',from)
      // console.log('to',to)
      if (from.meta.keepAlive) {
        this.arr.includes(from.name) || this.arr.push(from.name)
      } else {
        var name = from.name
        if (this.arr.includes(name)) {
          var index = this.arr.findIndex(function (item) {
            console.log('1111', item)
            return item === name
          })
          this.arr.splice(index, 1)
        }
      }
      if (to) {
        // switch (to.name) {
        //   // 需要缓存的页面
        //   case 'picshow':
        //   case 'monselect':
        //     this.arr.includes(to.name) || this.arr.push(to.name)
        //     break
        //   default:
        //     break
        // }
      }
      // console.log(`从${from.name}去${to.name},缓存页面有： ${this.arr}`)
    }
  }
  // created() {
  //   var nowTime = new Date().getTime()
  //   var publishOver = new Date('2020/07/31 23:59:00')
  //   if (nowTime > publishOver) {
  //     this.$store.commit('SET_PUBLISHOVER', 1)
  //   }
  // }
}

</script>



// WEBPACK FOOTER //
// src/App.vue